<template>
    <button class="page-nav" @click='goback'>BACK</button>
</template>

<script>
export default {
    methods: {
       goback() {
           return this.$router.go(-1)
       } 
    }
}
</script>

<style lang="scss" scoped>
.page-nav {
    position: fixed;
    top:50%;
    left:-10px;
    cursor: pointer;
    transform: rotate(90deg);
    background: none;
    border: none;
    color:#fff;
    transition: all 200ms ease;
    &:hover {
        font-size: 120%;
        transition: all 200ms ease;
    }
}

</style>